import React from 'react';
import { Text, Platform } from 'react-native';
import packages from '../packages';
import { mainSite } from './config.js';

async function loadAppJson() {
  try {
    const config = await import('../app.json');
    return config.default || config;
  } catch (err) {
    console.error("Failed to load app.json: ", err);
    return null;
  }
}

function getParsedModule(code, moduleName, packages) {
  const _this = Object.create(packages);
  function require(name) {
    if (!(name in _this) && moduleName === name) {
      let module = { exports: {} };
      _this[name] = () => module;
      let wrapper = Function('require, exports, module', code);
      wrapper(require, module.exports, module);
    } else if (!(name in _this)) {
      throw `Module '${name}' not found`;
    }

    // Check if _this[name] is a function or a plain object
    if (typeof _this[name] === 'function') {
      return _this[name]().exports;
    } else {
      return _this[name];
    }
  }
  const moduleExports = require(moduleName);
  const componentFunction = moduleExports.default || moduleExports;
  return componentFunction;
}

export async function fetchComponent(id) {
  const appJson = await loadAppJson();

  try {
    let serverUrl;

    // if (Platform.OS === 'android') {
    //   serverUrl = 'http://192.168.1.64:8080';
    // } else {
    //   serverUrl = 'http://192.168.1.64:8080';
    // }

    // console.log(serverUrl);
    // const urlToUse = `${serverUrl}/${id}.js?time=${Date.now()}`;
    // console.log(urlToUse);

    const urlToUse = `${mainSite}/app-components/${id}.js?time=${Date.now()}`;
    const text = await fetch(urlToUse).then((a) => {
      if (!a.ok) {
        throw new Error('Network response was not ok');
      }
      return a.text();
    });
    const extendedPackages = { ...packages, appJson };
    const parsedModule = getParsedModule(text, id, extendedPackages);
    return { default: parsedModule };
  } catch (error) {
    console.error(`Error fetching or parsing component "${id}":`, error);
    return {
      default() {
        return <Text>Failed to Render</Text>;
      },
    };
  }
}

